import localStorageService from '@/utils/local-storage-service'
import * as types from '../mutation-types'

const localStorageKey = 'searchInfo'

const state = {
  get data () {
    let data = localStorageService.getItem(localStorageKey)
    return data || {shop: -1, date: null, dateRange: []}
  },
  set data (v) {
    localStorageService.setItem(localStorageKey, v)
  }
}

const actions = {
  SetSearchInfo ({ commit }, data) {
    commit(types.SearchInfoSet, data)
  },
  ClearSearchInfo ({commit}) {
    commit(types.SearchInfoClear)
  }
}

const mutations = {
  [types.SearchInfoSet] (state, data) {
    let oldData = state.data
    state.data = {
      shop: data.shop != null ? data.shop : oldData.shop,
      date: data.date != null ? data.date : oldData.date,
      dateRange: data.dateRange != null ? data.dateRange : oldData.dateRange
    }
  },
  [types.SearchInfoClear] (state) {
    localStorageService.removeItem(localStorageKey)
    state.data = {...state.data}
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search-info.js